import AttendancePeriods from './src/main.js'

// eslint-disable-next-line space-before-function-paren
const install = function(Vue, opts = {}) {
  if (install.installed) return

  // 考勤时段
  Vue.prototype.$attendancePeriods = AttendancePeriods
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default { install }
